import SingleClientReportPage from './SingleClientReportPage';

export default SingleClientReportPage;


// WEBPACK FOOTER //
// ./src/features/reports/pages/single-client-report-page/index.js